import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist over the RuleCurrent EC, used to pick a relationship's CHILD rule.
// Display = the rule's Name; value = RuleUSID (the LOGICAL rule, not a revision) so the relationship
// survives every revise on that end. RuleCurrent lists exactly one row per rule — the revision it
// currently resolves to — which is why a never-published DRAFT is still pickable here.
class RuleChildPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "RuleChild";
        this.static = false;
        this.enterpriseComponent = "RuleCurrent";
        this.useRealm = false;
        // Persona-sensitive: options are scoped to the active persona via the EC's visibility headers.
        this.visibilityType = "Persona";
        this.serverFilter = true;
        this.serverFilterOperator = "Contains";
        this.serverFilterLimit = 50;
        this.mustMatchOption = true;
        // Exclude the chosen Parent so a rule can't relate to itself. The server rejects a self-edge
        // too (CC-RULE-SELF) — this just keeps it out of the list.
        this.excludeEnterpriseComponentAttributes = ["ParentUSID"];
        this.searchSpecification = null;
        this.sortSpecification = {"Name": "ASC"};
        this.typeField = "Name";
        this.typeValue = "RuleUSID";
        this.allowNoSelection = false;
    }
}

export default RuleChildPicklistMetadata;
